"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentResourceSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const assignment_serializer_1 = require("./assignment.serializer");
const scoring_settings_serializer_1 = require("./scoring-settings.serializer");
class AssignmentResourceSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(assignmentSerializer = new assignment_serializer_1.AssignmentSerializer(), scoringSettingsSerializer = new scoring_settings_serializer_1.ScoringSettingsSerializer()) {
        super();
        this.assignmentSerializer = assignmentSerializer;
        this.scoringSettingsSerializer = scoringSettingsSerializer;
    }
    serializeOne(data) {
        return {
            id: data.id,
            assignment: data.assignment
                ? this.assignmentSerializer.serializeOne(data.assignment)
                : null,
            resourceId: data.resourceId,
            resourceType: data.resourceType,
            parentId: data.parentId,
            parentType: data.parentType,
            sequence: data.sequence,
            curriculumId: data.curriculumId,
            evidenceRequired: data.evidenceRequired,
            scoringSettings: data.scoringSettings
                ? this.scoringSettingsSerializer.serializeOne(data.scoringSettings)
                : null,
            teacherGuidance: data.teacherGuidance || [],
        };
    }
}
exports.AssignmentResourceSerializer = AssignmentResourceSerializer;
//# sourceMappingURL=assignment-resource.serializer.js.map